import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { selectUser, selectLoggedIn } from "../../store/slices/auth/slice";

const ProtectedRoute = ({
  children,
  requiredRole = null,
  adminOnly = false,
  userOnly = false,
}) => {
  const user = useSelector(selectUser);
  const isLoggedIn = useSelector(selectLoggedIn);
  const location = useLocation();

  // Show loading while checking authentication (loggedIn is null during initial load)
  if (isLoggedIn === null) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <l-line-spinner size="32" stroke="3" speed="1" color="var(--accent)" />
      </div>
    );
  }

  // If not logged in, redirect to login and preserve the requested destination
  if (!isLoggedIn || !user) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/pristup?redirect=${redirect}`} replace />;
  }

  // Admin only route protection
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/korisnicki-panel/kursevi" replace />;
  }

  // User only route protection
  if (userOnly && user.role !== "user") {
    return <Navigate to="/admin-panel" replace />;
  }

  // Specific role requirement
  if (requiredRole && user.role !== requiredRole) {
    // Redirect based on user's actual role
    if (user.role === "admin") {
      return <Navigate to="/admin-panel" replace />;
    } else {
      return <Navigate to="/korisnicki-panel/kursevi" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
